import api from './api';

// 내 제안 조회
export const getMyOffers = async () => {
  const response = await api.get('/swap/my-offers');
  return response.data;
};

// 모든 제안 조회 (매칭용)
export const getAllOffers = async () => {
  const response = await api.get('/swap/offers');
  return response.data;
};

// 제안 생성
export const createOffer = async (giveDate: Date, wantDate: Date, reason: string) => {
  const response = await api.post('/swap/offers', {
    giveDate: giveDate.toISOString(),
    wantDate: wantDate.toISOString(),
    reason,
  });
  return response.data;
};

// 제안 취소
export const cancelOffer = async (offerId: string) => {
  const response = await api.patch(`/swap/offers/${offerId}/cancel`);
  return response.data;
};

// 요청 생성 (제안에 응답)
export const createRequest = async (offerId: string, giveDate: Date, contact?: string) => {
  const response = await api.post('/swap/requests', {
    offerId,
    giveDate: giveDate.toISOString(),
    contact,
  });
  return response.data;
};

// 요청 승인
export const acceptRequest = async (requestId: string) => {
  const response = await api.patch(`/swap/requests/${requestId}/accept`);
  return response.data;
};

// 요청 거절
export const rejectRequest = async (requestId: string) => {
  const response = await api.patch(`/swap/requests/${requestId}/reject`);
  return response.data;
};
